// (c) Copyright 2024 Hewlett Packard Enterprise Development LP

import { NavigationEventType } from "../events"

export function onUrlChange(callback) {
  let lastUrl
  return (e) => {
    const url = e.detail.href
    if (url !== lastUrl) {
      callback(e)
      lastUrl = url
    }
  }
}

/**
 * Track URL changes.
 */
export class UrlChange {
  #isRunning = false
  #listener

  constructor(callback) {
    this.#listener = onUrlChange(callback)
  }

  start() {
    if (this.#isRunning) {
      return
    }

    window.addEventListener(NavigationEventType.SHELL, this.#listener)
    this.#isRunning = true
  }

  stop() {
    window.removeEventListener(NavigationEventType.SHELL, this.#listener)
    this.#isRunning = false
  }
}

/**
 * Fire a callback when navigating away from the page.
 */
export class PageHide {
  #listener

  constructor(callback) {
    this.#listener = callback
  }

  start() {
    window.addEventListener("pagehide", this.#listener)
  }

  stop() {
    window.removeEventListener("pagehide", this.#listener)
  }
}
